module.exports = __webpack_public_path__ + "img/Symbol_H2.25fbe610.png";